import React from 'react';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import QuestionInput from './chatbot/QuestionInput';
import GenieQuestion from './chatbot/GenieQuestion';
import { useFarmChatbot  } from '../hooks/useFarmChatbot'
import { useDataChatbot  } from '../hooks/useDataChatbot'

const Footer = () => {
  const location = useLocation()
  const { queryFarmChatbot } = useFarmChatbot()
  const { queryDataChatbot } = useDataChatbot()
  const path = location.pathname.replace('/','')

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        backgroundColor: '#f2f2f2',
        textAlign: '-webkit-center'
      }}>
      { path === 'farm' ? <QuestionInput handleSendClick={queryFarmChatbot} /> : <></> }
      { path === 'data' ? <QuestionInput handleSendClick={queryDataChatbot} /> : <></> }
      { path === 'genie' ? <GenieQuestion /> : <></> }
    </Box>
  );
}

export default Footer;